<template>
    <div>
        <ul class="list listGame"
            v-if="gameListData.length > 0">
            <li v-for="(item, index) in gameListData"
                :key="index">
                <a href="javascript:;"
                   class="item"
                   @click="fnPlayGame({
            url: item.play_url,
            orientation:item.orientation,
            downloadurl:item.downloadurl,
            coreType: item.core_type,
            gameType: item.game_type,
            gameCode: item.game_code,
            gameName: item.game_name,
            serverName: item.server_name,
            serverId: item.server_id,
            idx: index + 1,
            page_block_id: 7,
            launch:item.launch || ''})">
                    <div class="top">
                        <div class="img">
                            <img :src="item.logo_small"
                                 alt />
                        </div>
                        <div class="txt">
                            <div class="gameName"
                                 v-text="item.game_name"></div>
                            <div class="gameTag"
                                 v-text="item.model_name"></div>
                            <span class="btnPlayGame">进入游戏</span>
                        </div>
                    </div>
                    <div class="btm">{{item.tips}}</div>
                </a>
            </li>
        </ul>
        <div class="listEmpty"
             v-else>
            <empty-data>暂无数据，请稍候再试</empty-data>
        </div>
    </div>
</template>

<script>
import EmptyData from '@/common/EmptyData'
export default {
    name: 'GameList',
    props: {
        listData: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            gameListData: []
        }
    },
    components: {
        EmptyData
    },
    watch: {
        listData () {
            this.fnInitDom()
        }
    },
    mounted () {
        this.$nextTick(() => {
            if (this.listData.length > 0) {
                this.fnInitDom()
            }
        })
    },
    methods: {
        fnPlayGame (o) {
            this.$emit('fnBtnClick', o)
        },
        fnInitDom () {
            this.gameListData = this.listData
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
